import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  OfficeSuppliesRefurbishType,
  OfficeSuppliesRefurbishValues,
  ValuesOfficeSuppliesRefurbish,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'OFFICE_SUPPLIES_REFURBISH';
const SECTORS: Sector[] = ['SITE'];

export function mapToOfficeSuppliesRefurbishAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesOfficeSuppliesRefurbish>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const officeSuppliesRefurbishType = mapToOfficeSuppliesRefurbishType(row);
  const count = mapToCount(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      officeSuppliesRefurbishType,
      count,
    },
  };
  return answer;
}

function mapToOfficeSuppliesRefurbishType(
  row: ImportedRow,
): OfficeSuppliesRefurbishType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<OfficeSuppliesRefurbishType>(
    tgsValue,
    OfficeSuppliesRefurbishValues,
  );
  if (!result) {
    throw new ImportMappingError('officeSuppliesRefurbishType', tgsValue, row);
  }
  return result;
}

function mapToCount(row: ImportedRow): number {
  const tgsValue = row['Quantity'];
  const result = parseInt(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('count', tgsValue, row);
  }
  return result;
}
